<app-loader [context]="'page-content'">
	<ng-container *ngIf="loader.completed">
		<div class="insurance-suggestions">
			<app-page-title [pagetitle]="'Оформить страховку'"></app-page-title>

			<ul class="showcase-products">
				<ng-container *ngFor="let item of suggestions; let i = index">
					<li
						class="showcase-products__item"
						*ngIf="item"
					>
						<app-route-action-link [action]="item.routeAction">
							<div class="showcase-products__item-image-wrapper">
								<app-product-image [image]="item.image"></app-product-image>
							</div>
						</app-route-action-link>

						<section class="showcase-products__item-advantages">
							<h2 class="showcase-products__item-advantages-title">
								{{ item.insuranceName }}
							</h2>
							<ul class="showcase-products__item-advantages-list">
								<li
									class="showcase-products__item-advantage"
									*ngFor="let benefit of item.benefits"
								>
									{{ benefit }}
								</li>
							</ul>
						</section>
						<div class="showcase-products__button-wrapper">
							<app-route-action-link
								[action]="item.routeAction"
								[type]="'button'"
								[class]="{ button: !item.routeAction.route }"
							>
								Оформить
							</app-route-action-link>
						</div>
					</li>
				</ng-container>
			</ul>
		</div>
	</ng-container>
</app-loader>
